// this gets updated automatically
export var version = '3.1.2';